import { render, staticRenderFns } from "./AddVideoForm.vue?vue&type=template&id=8a754396&"
import script from "./AddVideoForm.vue?vue&type=script&lang=js&"
export * from "./AddVideoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports